export const EFtpDocType = {
  "0": "UNKNOWN",
  "1": "HOTEL_ANIXE",
  "2": "HOTEL_EXPEDIA",
  "3": "HOTEL_GIATA",
  "4": "HOTEL_HENGEFLED",
  "5": "HOTEL_IATI",
  "6": "HOTEL_PAXIMUM",
  "7": "ARGUS_FLIGHT",
  "8": "ARGUS_HOTEL",
  "9": "TOUREX_FLIGHT",
  "10": "TOUREX_HOTEL",
  "11": "HOTEL_RATEHAWK",
  "12": "HOTEL_TRAVELGATEX",
  "13": "PACKAGE_SCHMETTERLING",
  "1001": "VENTUS_FLIGHT",
  "1002": "VENTUS_HOTEL",
  "1003": "FREEBIRD_FLIGHT_TIMETABLE",
  "-1": "ALL"
};